import axios from "axios";
import camelcaseKeys from "camelcase-keys";
import snakecaseKeys from "snakecase-keys";
import sha256 from "js-sha256"

export class Client{

    dispatch;
    axiosClient;
    cachedUser = null;

    constructor(navigation) {

        const viewerregex = /^.*\/viewer\/\?.+/;
        const localeegex = /locale=[a-z]{2}/;

        const commonTransformRequest = [function(data, headers) {
            const token = localStorage.getItem('sot');

            if (token) {
                headers['Authorization'] = 'Bearer ' + token;
            }

            return data;
        }, ...axios.defaults.transformRequest];

        const commonTransformResponse = [(data, headers, status ) => {
            if (status && status === 403 && data !== null && data !== '' ) {
                const resp = JSON.parse(data);

                if (resp && resp.message === 'login') {
                    const viewercheck = window.location.href.match(viewerregex);
                    if ( viewercheck ) {
                        const locale = viewercheck[0].match(localeegex);
                        const urlParams = [];
                        if ( locale ) urlParams.push( locale );
                        if (resp.errorInfo) {
                            urlParams.push( 'deactivateCopyErrorInfoButton=' + resp.errorInfo.deactivateCopyErrorInfoButton );
                            urlParams.push( 'homeUrl=' + resp.errorInfo.linkErrorPageHomeButton );
                        }
                        window.location.href = 'error/440' + ( urlParams.length > 0 ? '?' + urlParams.join( '&' ) : '' );
                    } else if (window.location.hash !== '#/') {
                        window.location.href = window.location.pathname;
                    }
                }
            }
            return data;
        }, ...axios.defaults.transformResponse];

        this.axiosClient = axios.create({
            baseURL: '/api/v1',
            transformRequest: commonTransformRequest,
            transformResponse: commonTransformResponse
        });

        this.axiosClientV2 = axios.create({
            baseURL: '/api/v2',
            transformRequest: commonTransformRequest,
            transformResponse: commonTransformResponse
        });

    }

    setDispatch(dispatch) {
        this.dispatch = dispatch;
    }

    getErrorState(error) {
        return {
            state: {
                error: {
                    status: error.status,
                        timestamp: error.headers.get("date")
                }
            }
        }
    }

    apiLogin = (data, success, error) => {
        this.axiosClient.post("/usermanagement/login", {login: data.login, password: data.password})
            .then(response => {
                localStorage.setItem('sot', response.data.token);
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiLogout = (success, error) => {
        this.cachedUser = null;
        this.axiosClient.delete("/session", {data:{session:"kill"}})
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiGetUser = (data, success, error) => {
        if (this.cachedUser) {
            success(this.cachedUser);
            return;
        }
        this.axiosClient.get("/user?roles=true")
            .then(response => {
                this.cachedUser = response.data;
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiDeleteUser = (data, success, error) => {
        this.axiosClient.delete("/usermanagement/user/"+data.userId, {data:"none"})
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiUpdateUser = (data, success, error) => {
        this.axiosClient.put("/usermanagement/user",snakecaseKeys(data))
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiUpdateUsers = (data, success, error) => {
        this.axiosClient.put("/usermanagement/users",snakecaseKeys(data))
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiCreateUser = (data, success, error) => {
        this.axiosClient.post("/usermanagement/user",snakecaseKeys(data))
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiGetCountries = (data, success, error) => {
        this.axiosClient.get("/usermanagement/countries")
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiGetLanguages = (data, success, error) => {
        this.axiosClient.get("/usermanagement/languages")
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiGetSettings = (data, success, error) => {
        this.axiosClient.get("/settings")
            .then(response => {
                success(camelcaseKeys(response.data));
            }).catch((data) => error(data.response));
    };

    apiGetNotificationSettings = (data, success, error) => {
        this.axiosClient.get("/usermanagement/notification")
            .then(response => {
                success(camelcaseKeys(response.data));
            }).catch((data) => error(data.response));
    };

    apiUpdateNotificationSettings = (data, success, error) => {
        this.axiosClient.put("/usermanagement/notification", snakecaseKeys(data))
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiSetUserPassword = (data, success, error) => {
        this.axiosClient.patch("/usermanagement/user/" + data.userId + "/password", data)
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiAddUserCredits = (data, success, error) => {
        this.axiosClient.patch("/usermanagement/user/" + data.userId + "/credits", {credits: data.credits})
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiGetUserManagementUsers = (data,offset,limit,success,error) => {
        this.axiosClient.get("/usermanagement/users/" + offset + "/" + limit)
            .then(response => {
                success(camelcaseKeys(response.data,{deep:true}));
            }).catch((data) => error(data.response));
    }

    apiSearchUserManagementUsers = (data,offset,limit,success,error) => {
        this.axiosClient.patch("/usermanagement/users/search/" + offset + "/" + limit,data)
            .then(response => {
                success(camelcaseKeys(response.data,{deep:true}));
            }).catch((data) => error(data.response));
    }

    apiGetUserManagementUser = (data,success,error) => {
        this.axiosClient.get("/usermanagement" +
            "/user/" + data.userId)
            .then(response => {
                success(camelcaseKeys(response.data));
            }).catch((data) => error(data.response));
    }

    apiSetUserActive = (data,success,error) => {
        this.axiosClient.patch("/usermanagement/user/" + data.userId + "/active/" + data.active, {data: "none"})
            .then(response => {
                success(camelcaseKeys(response.data));
            }).catch((data) => error(data.response));
    }

    apiInviteUser = (data,success,error) => {
        this.axiosClient.patch("/usermanagement/user/invite", snakecaseKeys(data))
            .then(response => {
                success(camelcaseKeys(response.data));
            }).catch((data) => error(data.response));
    }

    apiCreateLicense = (data, success, error) => {
        this.axiosClient.post("/usermanagement/license", data)
            .then(response => {
                success(camelcaseKeys(response.data, {deep: true}));
            }).catch((data) => error(data.response));
    };

    apiGetLicensedUsers = (data, offset, limit, sortField, sortDir, success, error) => {
        let params = [];
        if (sortField) params.push("sortField=" + sortField);
        if (sortDir) params.push("sortDir=" + sortDir);
        let base = "/usermanagement/licensed-users" + (offset != null && limit != null ? "/" + offset + "/" + limit : "");
        let url = base + (params.length > 0 ? "?" + params.join("&") : "");
        this.axiosClient.get(url)
            .then(response => {
                success(camelcaseKeys(response.data, {deep: true}));
            }).catch((data) => error(data.response));
    }

    apiSearchLicensedUsers = (data, offset, limit, sortField, sortDir, success, error) => {
        let params = [];
        if (sortField) params.push("sortField=" + sortField);
        if (sortDir) params.push("sortDir=" + sortDir);
        let base = "/usermanagement/licensed-users/search" + (offset != null && limit != null ? "/" + offset + "/" + limit : "");
        let url = base + (params.length > 0 ? "?" + params.join("&") : "");
        this.axiosClient.patch(url, data)
            .then(response => {
                success(camelcaseKeys(response.data, {deep: true}));
            }).catch((data) => error(data.response));
    }

    apiUpdateUserLicense = (data, success, error) => {
        this.axiosClient.patch("/usermanagement/user/" + data.userId + "/license", {action: data.action, expiry: data.expiry})
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    }

    apiDeleteLicensedUser = (data, success, error) => {
        this.axiosClient.delete("/usermanagement/licensed-users/" + data.userId, {data: "none"})
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    }

    apiGetAllDelegations = (success, error) => {
        this.axiosClientV2.get("/delegation/all")
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiGetDelegationsForUser = (userId, success, error) => {
        this.axiosClientV2.get("/delegation/user/" + userId)
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiGetGrantedDelegationsForUser = (userId, success, error) => {
        this.axiosClientV2.get("/delegation/user/" + userId + "/granted")
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiCreateDelegationForUser = (userId, delegation, mailNotification, success, error) => {
        let url = "/delegation/user/" + userId;
        if (mailNotification === false) url += "?mailNotification=false";
        this.axiosClientV2.post(url, delegation)
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiUpdateDelegation = (delegationId, delegation, success, error) => {
        this.axiosClientV2.put("/delegation/" + delegationId, delegation)
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };

    apiDeleteDelegation = (delegationId, success, error) => {
        this.axiosClientV2.delete("/delegation/" + delegationId, {data: "none"})
            .then(response => {
                success(response.data);
            }).catch((data) => error(data.response));
    };
}




